<template>
	<div class="recommend-container">
		<div class="recommend-content">
			<!-- vip滚动区域--start -->
			<div class="vip-container">
				<div class="vip-content">
					<div class="vip-swiper">
						<ul class="swiper-wrapper">
							<li v-for="(item, index) in vipMessages" :key="index" class="swiper-slide">
								<img src="@/assets/qualificationQuery/vip_icon.png" alt="" />
								<p>{{ item.message }}</p>
								<el-button>立即开通</el-button>
							</li>
						</ul>
					</div>
					<div class="export-content">
						<span>
							<svg-icon icon-class="export" class="icon" />
							关注
						</span>
						<span>
							索要简历
							<span class="tag-member-mini">VIP</span>
						</span>
						<span>资质背景</span>
						<span>人员分析</span>
					</div>
				</div>
			</div>
			<!-- vip滚动区域--end -->

			<div class="section-detail-wrapper">
				<div class="section-detail-left">
					<!-- 基本信息--start -->
					<div class="resume-info">
						<div class="avatar-container">
							<img src="@/assets/index/index-zw2.png" alt="头像" class="avatar-img" />
						</div>
						<div class="basic-info">
							<div class="name-container">
								<h2 class="name">张某某</h2>
								<div class="tags">
									<span class="tag tag-status">离职随时到岗</span>
									<span class="tag">武汉·洪山区</span>
									<span class="tag">3-5年</span>
									<span class="tag">本科</span>
									<span class="tag">25岁</span>
								</div>
							</div>
							<div class="cert-info">
								<div class="cert-item">
									<span class="cert-label">求职意向：</span>
									<span class="cert-value">PMC注册安全工程师</span>
								</div>
								<div class="cert-item">
									<span class="cert-label">专业证书：</span>
									<span class="cert-value">建筑电工</span>
								</div>
								<div class="cert-item">
									<span class="cert-label">更新时间：</span>
									<span class="cert-value">2024-12-25</span>
								</div>
							</div>
						</div>
						<div class="salary-info">
							<div class="salary-label">期望薪资</div>
							<div class="salary">15k~20k/月</div>
						</div>
					</div>
					<!-- 基本信息--end -->

					<!-- 简历详情--start -->
					<div class="section-detail">
						<!-- 个人信息 -->
						<div class="section-dot-title loose">个人信息</div>
						<div class="section-info">
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">当前求职状态：</span>
									<span class="info-value">离职</span>
								</div>
								<div class="info-item">
									<span class="info-label">性别：</span>
									<span class="info-value">男</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">出生年月：</span>
									<span class="info-value">2001-02-24</span>
								</div>
							</div>
						</div>

						<!-- 求职意向 -->
						<div class="section-dot-title loose">求职意向</div>
						<div class="section-info">
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">求职类型：</span>
									<span class="info-value">全职/兼职</span>
								</div>
								<div class="info-item">
									<span class="info-label">期望职位：</span>
									<span class="info-value">xxx/xxx/xxx</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">就业地区：</span>
									<span class="info-value">武汉/上海/xx</span>
								</div>
								<div class="info-item">
									<span class="info-label">期望薪资：</span>
									<span class="info-value">15k</span>
								</div>
							</div>
						</div>

						<!-- 自我介绍 -->
						<div class="section-dot-title loose">自我介绍</div>
						<div class="section-info">
							<p>
								输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字
							</p>
						</div>

						<!-- 从业经历 -->
						<div class="section-dot-title loose">从业经历</div>
						<div class="section-info">
							<!-- 从业经历时间轴 -->
							<div class="timeline">
								<div class="timeline-item">
									<div class="timeline-header">
										<div class="timeline-title">
											<i class="timeline-dot"></i>
											湖北省某A公司
										</div>
										<div class="timeline-timestamp">2013-07-25 至 2016-07-25</div>
									</div>
									<div class="timeline-content">
										<div class="timeline-info">
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">注册专业：</span>
												<span class="timeline-info-item__value">房屋建筑工程、市政公用工程</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">注册类型：</span>
												<span class="timeline-info-item__value">延续注册</span>
											</div>
										</div>
									</div>
								</div>
								<div class="timeline-item">
									<div class="timeline-header">
										<div class="timeline-title">
											<i class="timeline-dot"></i>
											湖北省某A公司
										</div>
										<div class="timeline-timestamp">2013-07-25 至 2016-07-25</div>
									</div>
									<div class="timeline-content">
										<div class="timeline-info">
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">注册专业：</span>
												<span class="timeline-info-item__value">房屋建筑工程、市政公用工程</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">注册类型：</span>
												<span class="timeline-info-item__value">延续注册</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 资格证书 -->
						<div class="section-dot-title loose">资格证书</div>
						<div class="section-info">
							<div class="timeline">
								<div class="timeline-item">
									<div class="timeline-header">
										<div class="timeline-title">
											<i class="timeline-dot"></i>
											xxxx证书
											<span class="cert-status">已注册</span>
										</div>
										<div class="timeline-timestamp">2013-07-25 至 2016-07-25</div>
									</div>
									<div class="timeline-content">
										<div class="timeline-info">
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">证书类型：</span>
												<span class="timeline-info-item__value">xxxx类型</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">有效期：</span>
												<span class="timeline-info-item__value">2025-01-03</span>
											</div>
										</div>
									</div>
								</div>
								<div class="timeline-item">
									<div class="timeline-header">
										<div class="timeline-title">
											<i class="timeline-dot"></i>
											xxxx证书
											<span class="cert-status">已注册</span>
										</div>
										<div class="timeline-timestamp">2013-07-25 至 2016-07-25</div>
									</div>
									<div class="timeline-content">
										<div class="timeline-info">
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">证书类型：</span>
												<span class="timeline-info-item__value">xxxx类型</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">有效期：</span>
												<span class="timeline-info-item__value">2025-01-03</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 我的业绩 -->
						<div class="section-dot-title loose">我的业绩</div>
						<div class="section-info">
							<div class="timeline">
								<div class="timeline-item">
									<div class="timeline-header">
										<div class="timeline-title">
											<i class="timeline-dot"></i>
											xxxxxxxxxxxx项目
										</div>
										<div class="timeline-timestamp">2013-07-25 至 2016-07-25</div>
									</div>
									<div class="timeline-content">
										<div class="timeline-info">
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">个人业绩记录编号：</span>
												<span class="timeline-info-item__value">xxxx</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">项目编号：</span>
												<span class="timeline-info-item__value">xxxxxxxx</span>
											</div>
											<div class="timeline-info-item">
												<span class="timeline-info-item__label">数据等级：</span>
												<span class="timeline-info-item__value">xxxx</span>
											</div>
										</div>
										<div class="timeline-info">
											<div class="timeline-info-item full-width">
												<span class="timeline-info-item__label">本人在工程中所起作用：</span>
												<span class="timeline-info-item__value">xxxxxxxxxxxxxxxxxxxxxxxx</span>
											</div>
										</div>
										<div class="timeline-info">
											<div class="timeline-info-item full-width">
												<span class="timeline-info-item__label">详细：</span>
												<span class="timeline-info-item__value detail-text">
													输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 简历详情--end -->
				</div>
				<div class="section-detail-right">
					<div class="data-card">
						<div class="section-simple-title">
							<h4>
								人员画像
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</h4>
						</div>

						<div class="radar-chart-box">
							<radar-chart :chart-data="portraitData" :indicator="portraitIndicator" title="能力评估雷达图" height="230px" />
						</div>
					</div>

					<!-- 同类型人才--start -->
					<div class="similar-talent">
						<div class="section-simple-title">
							<h4>同类型人才</h4>
							<div class="action-btns">
								<button class="compare-btn" type="button">
									对比分析
									<span class="tag-member-mini tag-member--svip">SVIP</span>
								</button>
							</div>
						</div>

						<div class="talent-list">
							<!-- 人才卡片 -->
							<div class="talent-card">
								<div class="talent-tag">在职/人才库</div>
								<div class="talent-content">
									<!-- 头像和基本信息 -->
									<div class="talent-header-block">
										<div class="talent-avatar">
											<img src="@/assets/index/index-zw2.png" alt="头像" />
										</div>
										<div class="talent-basic">
											<h3 class="talent-name">朱迪</h3>
											<p class="talent-position">PMC注册安全工程师</p>
											<p class="talent-salary">15k~20k/月</p>
										</div>
									</div>

									<!-- 标签和描述 -->
									<div class="talent-detail-block">
										<div class="talent-tags">
											<span class="tag">25岁</span>
											<span class="tag">本科</span>
											<span class="tag">3年</span>
											<span class="tag">一级建造师</span>
										</div>

										<div class="talent-desc">
											<p class="text-content">
												熟练操作设计相关软件，对专业基础知识掌握扎实，熟悉本专业基础范畴，对专业知识有较强的钻研精神
											</p>
											<a href="javascript:;" class="detail-link">详情 ></a>
										</div>
									</div>
								</div>
							</div>

							<!-- 人才卡片 -->
							<div class="talent-card">
								<div class="talent-tag">在职/人才库</div>
								<div class="talent-content">
									<!-- 头像和基本信息 -->
									<div class="talent-header-block">
										<div class="talent-avatar">
											<img src="@/assets/index/index-zw2.png" alt="头像" />
										</div>
										<div class="talent-basic">
											<h3 class="talent-name">朱迪</h3>
											<p class="talent-position">PMC注册安全工程师</p>
											<p class="talent-salary">15k~20k/月</p>
										</div>
									</div>

									<!-- 标签和描述 -->
									<div class="talent-detail-block">
										<div class="talent-tags">
											<span class="tag">25岁</span>
											<span class="tag">本科</span>
											<span class="tag">3年</span>
											<span class="tag">一级建造师</span>
										</div>

										<div class="talent-desc">
											<p class="text-content">
												熟练操作设计相关软件，对专业基础知识掌握扎实，熟悉本专业基础范畴，对专业知识有较强的钻研精神
											</p>
											<a href="javascript:;" class="detail-link">详情 ></a>
										</div>
									</div>
								</div>
							</div>

							<!-- 人才卡片 -->
							<div class="talent-card">
								<div class="talent-tag">在职/人才库</div>
								<div class="talent-content">
									<!-- 头像和基本信息 -->
									<div class="talent-header-block">
										<div class="talent-avatar">
											<img src="@/assets/index/index-zw2.png" alt="头像" />
										</div>
										<div class="talent-basic">
											<h3 class="talent-name">朱迪</h3>
											<p class="talent-position">PMC注册安全工程师</p>
											<p class="talent-salary">15k~20k/月</p>
										</div>
									</div>

									<!-- 标签和描述 -->
									<div class="talent-detail-block">
										<div class="talent-tags">
											<span class="tag">25岁</span>
											<span class="tag">本科</span>
											<span class="tag">3年</span>
											<span class="tag">一级建造师</span>
										</div>

										<div class="talent-desc">
											<p class="text-content">
												熟练操作设计相关软件，对专业基础知识掌握扎实，熟悉本专业基础范畴，对专业知识有较强的钻研精神
											</p>
											<a href="javascript:;" class="detail-link">详情 ></a>
										</div>
									</div>
								</div>
							</div>

							<!-- 人才卡片 -->
							<div class="talent-card">
								<div class="talent-tag">在职/人才库</div>
								<div class="talent-content">
									<!-- 头像和基本信息 -->
									<div class="talent-header-block">
										<div class="talent-avatar">
											<img src="@/assets/index/index-zw2.png" alt="头像" />
										</div>
										<div class="talent-basic">
											<h3 class="talent-name">朱迪</h3>
											<p class="talent-position">PMC注册安全工程师</p>
											<p class="talent-salary">15k~20k/月</p>
										</div>
									</div>

									<!-- 标签和描述 -->
									<div class="talent-detail-block">
										<div class="talent-tags">
											<span class="tag">25岁</span>
											<span class="tag">本科</span>
											<span class="tag">3年</span>
											<span class="tag">一级建造师</span>
										</div>

										<div class="talent-desc">
											<p class="text-content">
												熟练操作设计相关软件，对专业基础知识掌握扎实，熟悉本专业基础范畴，对专业知识有较强的钻研精神
											</p>
											<a href="javascript:;" class="detail-link">详情 ></a>
										</div>
									</div>
								</div>
							</div>

							<!-- 查看更多按钮 -->
							<button class="view-more-btn" type="button">查看更多</button>
						</div>
					</div>
					<!-- 同类型人才--end -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import RadarChart from '@/components/Chart/RadarChart.vue'

	export default {
		name: 'Recommend',
		components: {
			RadarChart
		},
		props: {},
		data() {
			return {
				vipMessages: [
					{ message: '李** 于3分钟前购买会员，一键解锁全部权益' },
					{ message: '王** 于5分钟前购买会员，一键解锁全部权益' },
					{ message: '张** 于10分钟前购买会员，一键解锁全部权益' }
				],
				// 人员画像雷达图数据
				portraitIndicator: [
					{ name: '专业技能', max: 100 },
					{ name: '稳定性', max: 100 },
					{ name: '风险', max: 100 },
					{ name: '诚信', max: 100 },
					{ name: '经验', max: 100 }
				],
				// 人员画像数据
				portraitData: [
					{
						value: [80, 90, 70, 85, 65],
						name: '个人能力'
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initSwiper()
		},
		methods: {
			initSwiper() {
				new Swiper('.vip-swiper', {
					direction: 'vertical', // 垂直方向滚动
					loop: true, // 循环滚动
					autoplay: {
						delay: 3000, // 3秒切换一次
						disableOnInteraction: false
					},
					slidesPerView: 1, // 每次显示1条
					spaceBetween: 0 // 间距为0
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/employment.scss';
	@import '~@/styles/timeline.scss';

	.recommend-container {
		background-color: #eff6f9;
		padding: 20px 0;
		.recommend-content {
			width: $main-page-width;
			margin: 0 auto;

			.section-detail-wrapper {
				.section-detail-left {
					display: flex;
					flex-direction: column;

					// 基本信息
					.resume-info {
						display: flex;
						align-items: center;
						background-color: #fff;
						padding: 30px 20px;
						margin-bottom: 20px;

						.avatar-container {
							width: 100px;
							height: 100px;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 40px;

							.avatar-img {
								width: 100%;
								object-fit: cover;
							}
						}

						.basic-info {
							flex: 1;

							.name-container {
								display: flex;
								align-items: center;
								margin-bottom: 15px;

								.name {
									margin-right: 15px;
									font-size: 24px;
									font-weight: bold;
								}

								.tags {
									display: flex;
									flex-wrap: wrap;

									.tag {
										background-color: #e5f1fc;
										color: #236fca;
										padding: 5px 10px;
										border-radius: 4px;
										margin-right: 10px;
										font-size: 16px;

										&.tag-status {
											margin-right: 30px;
											color: #fff;
											background-color: #2599fb;
											border-radius: 0px 10px 0px 10px;
										}
									}
								}
							}

							.cert-info {
								display: flex;
								.cert-item {
									margin-right: 20px;
									font-size: 16px;

									&:not(:last-child)::after {
										content: '|';
										margin-left: 20px;
										color: #999999;
									}

									.cert-label {
										color: #999999;
									}

									.cert-value {
										color: #333;
										font-weight: 500;
									}
								}
							}
						}

						.salary-info {
							min-width: 150px;
							text-align: left;

							.salary-label {
								font-size: 16px;
								color: #333333;
								margin-bottom: 15px;
							}

							.salary {
								font-size: 20px;
								font-weight: bold;
								color: #fe5012;
							}
						}
					}

					// 简历详情
					.section-detail {
						flex: 1;

						.timeline {
							.timeline-header {
								.cert-status {
									display: inline-block;
									margin-left: 10px;
									padding: 2px 8px;
									font-size: 14px;
									color: #52c41a;
									background-color: #f6ffed;
									border-radius: 4px;
								}
							}
						}
					}
				}

				// 数据分析
				.section-detail-right {
					.data-card {
						padding: 20px;
						background-color: #fff;
					}

					.similar-talent {
						flex: 1;
						background-color: #fff;
						padding: 20px;
						margin-top: 20px;

						.section-simple-title {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 20px;

							.action-btns {
								.compare-btn,
								.talent-btn {
									padding: 5px 12px;
									font-size: 16px;
									border-radius: 4px;
									cursor: pointer;
									border: none;

									position: relative;

									.tag-member-mini {
										position: absolute;
										top: -15px;
										right: -10px;
										padding: 0 7px;
									}
								}

								.compare-btn {
									background-color: #d3ecff;
									color: #236fca;
								}

								.talent-btn {
									background-color: #2599fb;
									color: #fff;
								}
							}
						}

						.talent-list {
							min-height: 960px;
							max-height: 960px;
							overflow: hidden;
							position: relative;

							/* 添加蒙层 */
							&::after {
								content: '';
								position: absolute;
								bottom: 0;
								left: 0;
								right: 0;
								height: 180px; /* 蒙层高度，可以根据需要调整 */
								background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9));
								pointer-events: none; /* 确保蒙层不会阻止点击 */
							}

							/* 查看更多按钮 */
							.view-more-btn {
								position: absolute;
								bottom: 20px;
								left: 50%;
								transform: translateX(-50%);
								z-index: 10;
								background-color: #236fca;
								color: white;
								border: none;
								border-radius: 4px;
								padding: 10px 30px;
								font-size: 16px;
								cursor: pointer;
								box-shadow: 0 2px 8px rgba(37, 153, 251, 0.3);

								&:hover {
									background-color: #1e8ae0;
								}
							}
						}

						.talent-card {
							position: relative;
							background-color: #f1f7ff;
							border-radius: 6px;
							padding: 20px;
							margin-bottom: 20px;

							.talent-tag {
								position: absolute;
								top: 0;
								right: 0;
								background-color: #2599fb;
								color: #fff;
								font-size: 12px;
								padding: 3px 10px;
								border-radius: 0 8px 0 8px;
							}

							.talent-content {
								display: flex;
								flex-direction: column;

								.talent-header-block {
									display: flex;
									margin-bottom: 15px;

									.talent-avatar {
										width: 80px;
										height: 80px;
										border-radius: 4px;
										overflow: hidden;
										margin-right: 15px;

										img {
											width: 100%;
											height: 100%;
											object-fit: cover;
										}
									}

									.talent-basic {
										flex: 1;

										.talent-name {
											font-size: 18px;
											font-weight: bold;
											color: #333;
											margin: 0 0 5px 0;
										}

										.talent-position {
											font-size: 16px;
											color: #666;
											margin: 0 0 5px 0;
										}

										.talent-salary {
											font-size: 16px;
											color: #ff5012;
											font-weight: bold;
											margin: 0;
										}
									}
								}

								.talent-detail-block {
									.talent-tags {
										display: flex;
										flex-wrap: wrap;
										margin-bottom: 10px;

										.tag {
											display: inline-block;
											background-color: #cae1ff;
											color: #1e94f8;
											font-size: 14px;
											padding: 2px 8px;
											border-radius: 4px;
											margin-right: 8px;
											margin-bottom: 5px;
										}
									}

									.talent-desc {
										position: relative;
										font-size: 14px;
										color: #666;
										line-height: 1.5;
										display: flex;
										flex-wrap: wrap;

										/* 文本内容部分 */
										.text-content {
											flex: 1;
											overflow: hidden;
											text-overflow: ellipsis;
											display: -webkit-box;
											-webkit-line-clamp: 3;
											-webkit-box-orient: vertical;
											margin-right: 5px;
										}

										.detail-link {
											color: #2599fb;
											text-decoration: none;
											white-space: nowrap;
											align-self: flex-end;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
